// One routing source for the creator iframe and its ancestry-picker preview badges.
const ANCESTRY_KITS: Readonly<Record<string, string>> = {
    'D1BD9BFA-43CE-D615-14DA-4B3098F47D32': 'ancestry.elf.high',
    'C58E26B5-547A-081E-3E76-B41CD335E5FA': 'ancestry.elf.dark',
    'CA2B1256-DB18-B51D-4CF3-C484B3029041': 'ancestry.elf.wood',
    '3FF230C3-59B5-BE67-3452-EA8F5035C191': 'ancestry.nephilim.light',
    '801B174A-E66E-0E25-FC64-673F81DA1ACD': 'ancestry.nephilim.dark',
    '6A45CB9D-09EF-A1E0-A603-812A1626F9B9': 'ancestry.dwarf',
    '8C2FB0B9-CB95-21F9-A9BE-AD29640BE793': 'ancestry.dwarf.dark', // "Dwarf, Dark" player ancestry (placeholder 2026-09-30)
    '5F7CF41E-D91F-9DEC-69C7-587DD015A44B': 'ancestry.halfolk',
    'F8D14A90-5502-65ED-AFAD-9EDE6BEDB5C1': 'ancestry.gnome.rock',
    '1892EF16-671A-4A8C-94EC-A637B2C68597': 'ancestry.gnome.forest',
    '68B9E080-C256-71E3-260A-4E30BDE23613': 'ancestry.gnome.dark', // "Gnome, Dark" (2026-10-07): fallback on the shared gnome rig + gnome-dark palette
    '0412241B-FC60-4414-CDE9-2F8AEEF18D63': 'ancestry.orc', // overnight run 2026-10-01, owner review pending
    '00C458BD-93EC-45CE-3F4D-D10EE05C822E': 'ancestry.goblin',
    'BA57B825-F810-3D77-A15A-21C946C2DE29': 'ancestry.dragonfolk', // owner 2026-10-14: normal creator entry, iterate on staging
};
const FIEND_KITS: Readonly<Record<string, string>> = {
    '6805DD8A-E159-9DAF-648D-D488433EB33F': 'ancestry.demonfolk',
    '700A3B33-9A51-DC1D-B3DA-D9DE62BB027E': 'ancestry.devilfolk',
};
const FIEND_REVISIONS = new Set(['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9', 'v10', 'v11', 'v12', 'v13', 'v14', 'v15']);
const UNIFIED_OPT_OUT_VALUES = new Set(['legacy', 'off', '0', 'false']);

export function creatorUnifiedPreviewEnabled(query: URLSearchParams): boolean {
    return !UNIFIED_OPT_OUT_VALUES.has((query.get('characterCreatorUnified') ?? '').trim().toLowerCase());
}

export function creatorFiendPreviewEnabled(query: URLSearchParams): boolean {
    return FIEND_REVISIONS.has(query.get('fiendFeatures') ?? '');
}

export function creatorAncestryPreviewKit(id: string, label: string): string | null {
    const key = id.toUpperCase();
    return ANCESTRY_KITS[key]
        ?? FIEND_KITS[key]
        ?? (Boolean(id) && /^human(?:\b|,)/i.test(label) ? 'ancestry.human' : null);
}
